<template>
  <div>
    <navbar />
  </div>
</template>

<script>
import navbar from '@/components/Navbar'

export default {
  components: {
    navbar
  },
  data () {
    return {
      parkings: [

      ]
    }
  },
  mounted () {

  },
  methods: {
    fetchParkings () {

    }
  }

}
</script>

<style>

</style>
